import {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'

import {getSystemTimezone} from '../../shared/hooks/useTimezone'

import {getQuickSelectionItems} from './useTimeRange'
import {useTimeRangeParam} from './useTimeRangeParam'
import {useTranslationPrefix} from './useTranslationPrefix'

type Type = 'performance' | 'status' | 'equipmentStatistics' | 'all'

export const useStatusInitialTimeRange = (type: Type) => {
  const [timeRangeLoaded, setTimeRangeLoaded] = useState<boolean>(false)
  const timezone = getSystemTimezone()
  const {t} = useTranslation()
  const {performancePrefix} = useTranslationPrefix()
  const [timeRange, setTimeRange] = useTimeRangeParam()
  const selectionItems = getQuickSelectionItems(
    (key) => t(`${performancePrefix}.${key}`),
    timezone,
    new Date(),
    type
  )

  useEffect(() => {
    if (timeRange && !selectionItems.find((item) => item.id === timeRange)) {
      setTimeRange(selectionItems[0].id)
    }
    setTimeRangeLoaded(true)
  }, [selectionItems, setTimeRange, timeRange])

  return timeRangeLoaded
}
